export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

import { recruitmentTrainingNavigationRoute } from './recruitmentTrainingNavigation'
const sidebarRoutes = {
  root: {
    name: 'dashboard-v2',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard-v2',
      displayName: 'Monthly Dashboard',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'scorecard',
      displayName: 'Scorecard',
      meta: {
        icon: 'assessment',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'ev-dashboard',
      displayName: 'EV Dashboard',
      meta: {
        icon: 'electric_car',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    recruitmentTrainingNavigationRoute,
    {
      name: 'reports',
      displayName: 'Financial Reports',
      meta: {
        icon: 'assessment',
        allowedRoles: ['finance', 'finance-staff'],
      },
      children: [
        {
          name: 'reports',
          displayName: 'All Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'vehicle-activity-reports',
          displayName: 'Vehicle Activity',
          meta: {
            icon: 'sensors',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'fleet-telemetry-reports',
          displayName: 'Fleet Telemetry',
          meta: {
            icon: 'sensors',
            allowedRoles: ['finance'],
          },
        },
      ],
    },
    {
      name: 'drivers',
      displayName: 'Driver Finance',
      meta: {
        icon: 'moped',
        allowedRoles: ['finance', 'finance-staff'],
      },
      children: [
        {
          name: 'drivers',
          displayName: 'Driver Management',
          meta: {
            icon: 'moped',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'trips',
          displayName: 'Trip Management',
          meta: {
            icon: 'route',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'finance-ledgers',
          displayName: 'Finance Ledger',
          meta: {
            icon: 'receipt_long',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'outbound-messages',
          displayName: 'Outbound Messages',
          meta: {
            icon: 'chat',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
        {
          name: 'invoices',
          displayName: 'Invoices',
          meta: {
            icon: 'request_quote',
            allowedRoles: ['finance', 'finance-staff'],
          },
        },
      ],
    },
    {
      name: 'financial-upload',
      displayName: 'Upload Financial Sheet',
      meta: {
        icon: 'upload_file',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: ['finance', 'finance-staff'],
      },
    },
  ],
}

export default sidebarRoutes
